import React, { useContext, useEffect, useState, useRef } from "react";
import {
  Form,
  Icon,
  Label,
  Search,
  Table,
  Button,
  Modal,
  Popup,
} from "semantic-ui-react";
import { AppContext } from "../../../Context/AppContext";
import { useToasts } from "react-toast-notifications";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { getAllOrdersOfUser } from "../../../constants";
import MDL_PROGRESS from "../../../components/cmp-progress/cmp-progress";
import MDL_UPDATE_BUILDING from "./mdl-update-building/mdl-update-building";
import {
  getSingleBuilding,
  getListofScheduler,
  getNote,
  downloadPestTracker,
  syncScheduler,
  deleteSchedulerOrder,
  orderDetailsGet,
} from "../../../constants";
import AppPagination from "../../../components/cmp-pagination/Pagination";
import CMP_PDF_VIEWER from "../../../components/cmp-pdf-viewer/cmp-pdf-viewer";
import CMP_ALERT from "../../../components/cmp-alert/cmp-alert";
import { isValid } from "date-fns";
import moment from "moment";
import SchedulerOrderList from "../../../components/cmp-scheduler-order-list/cmp-scheduler-order-list";
import "./BuildingImpersonate.css";

const BuildingImpersonate = () => {
  /* VARIABLE DECLARATIONS
	---------------------------------------------------------------------------------*/
  const {
    selectedBuilding,
    buildingUnits,
    userInfo,
    selected_units,
    sbuildingData,
    ShowHeaderSearch,
    defaultPane,
    OrderTabStatus,
    building_order_details,
    locationId,
    bInfo,
    isUserImpersonated,
    impersonator,
    appVersion,
    isAppVersionOutdated,
  } = useContext(AppContext);
  const [user, setUser] = userInfo;
  const [var_app_version] = appVersion;
  const [, set_is_app_version_outdated] = isAppVersionOutdated;
  const [building_info, setBuildingInfo] = bInfo;
  const [, setLocationId] = locationId;
  const [, set_add_unit] = selected_units;
  const [, set_default_pane] = defaultPane;
  const [, setBuildingUnits] = buildingUnits;
  const [, setBuildingOrder] = building_order_details;
  const [orderStatus, setOrderStatus] = OrderTabStatus;
  const [selected_building, setSelectedBuilding] = selectedBuilding;
  const [single_building_data, setSingleBuildingData] = sbuildingData;
  const [var_ShowHeaderSearch, setShowHeaderSearch] = ShowHeaderSearch;
  const [impersonated, setImpersonated] = isUserImpersonated;
  const [, setImpersonatorID] = impersonator;
  const [current_sort, set_current_sorted] = useState({
    sort_by: "order_number",
    sort_by_value: "DESC",
  });
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sortBy, setSortBy] = useState(3);
  const [orders, setOrders] = useState([]);
  const [pdf_url, set_pdf_url] = useState();
  const [schedulers, setSchedulers] = useState();
  const [totalOrders, setTotalOrders] = useState(0);
  const [buildingID, set_buildingID] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [var_mdl_alert, set_mdl_alert] = useState(false);
  const [alert_message, set_alert_message] = useState([]);
  const [selected_order, set_selected_order] = useState();
  const [var_mdl_progress, set_mdl_progress] = useState(false);
  const [var_add_building, set_var_add_building] = useState({});
  const [var_building_order, set_building_order] = useState({});
  const [open_pdf_viewer, set_open_pdf_viewer] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [mdl_update_building, set_mdl_update_building] = useState(false);

  const params = useParams();
  const history = useHistory();
  const location = useLocation();
  const { addToast } = useToasts();

  /* EVENT LISTENERS
	---------------------------------------------------------------------------------*/
  useEffect(() => {
    // Check if we are on the specific page and if the popup hasn't been dismissed
    if (
      location.pathname.includes("/building-impersonate/") &&
      // localStorage.getItem("popupDismissed") &&
      !mdl_update_building &&
      schedulers
    ) {
      const showpopup = async () => {
        try {
          const response = await fetch(
            getNote + params.building_id + "?note_type=Alert",
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                entityid: user.uuid,
                appversion: var_app_version,
              },
            },
          );
          const data = await response.json();
          if (data.code !== 200) {
            if (data?.version && data?.version !== var_app_version) {
              set_is_app_version_outdated(true);
            }
          }
          if (data?.data?.length) {
            set_mdl_alert(true);
            set_alert_message(data?.data);
          }
        } catch (error) {
          console.error("Error fetching data", error);
        }
      };

      // Directly call the function
      showpopup();
    } else {
      set_mdl_alert(false);
    }
  }, [schedulers, window.location.pathname]);

  useEffect(() => {
    if (params && params.building_id) {
      setSelectedBuilding(params.building_id);
    }
  }, [params, window.location.pathname]);

  useEffect(() => {
    setImpersonated(true);
  }, []);

  // useEffect(() => {
  //   if (selected_building && page > 0) {
  //     getBuildingOrders(page, limit);
  //     // getBuildingUnits()
  //   }
  // }, [limit, page, selected_building, current_sort]);
  // useEffect(() => {
  //   if (!selected_building || page <= 0) return;

  //   getBuildingOrders(page, limit);
  // }, [limit, page, selected_building, current_sort, reloadKey]);

  // useEffect(() => {
  //   if (!selected_building || page <= 0) return;
  //   getBuildingOrders(page, limit);
  // }, [limit, page, selected_building, current_sort, debouncedSearch]);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setDebouncedSearch(searchQuery);
  //   }, 400);

  //   return () => clearTimeout(timer);
  // }, [searchQuery]);

  // useEffect(() => {
  //   if (!selected_building) return;

  //   if (page !== 1) setPage(1);
  // }, [debouncedSearch]);

  // useEffect(() => {
  //   const delayDebounceFn = setTimeout(() => {
  //     if (selected_building) {
  //       if (page !== 1) {
  //         console.log("checkpoint 1");
  //         setPage(1);
  //       } else {
  //         setReloadKey((prev) => prev + 1);
  //       }
  //     }
  //   }, 400);

  //   return () => clearTimeout(delayDebounceFn);
  // }, [searchQuery]);

  // useEffect(() => {
  //   if (!selected_building) return;

  //   if (page !== 1) {
  //     setPage(1);
  //   } else {
  //     getBuildingOrders(1, limit);
  //   }
  // }, [sortBy]);

  useEffect(() => {
    getBuildingUnits();
  }, [
    mdl_update_building,
    limit,
    page,
    current_sort,
    window.location.pathname,
  ]);

  useEffect(() => {
    getSchedulerData();
  }, [buildingID, window.location.pathname]);

  // useEffect(() => {
  //   const delayDebounceFn = setTimeout(async () => {
  //     // Send Axios request here
  //     // getListOfCustomers();
  //     if (selected_building) {
  //       set_mdl_progress(true);
  //       await getBuildingOrders(1, limit);
  //       set_mdl_progress(false);
  //     }
  //   }, 400);

  //   return () => clearTimeout(delayDebounceFn);
  // }, [searchQuery]);

  // useEffect(() => {
  //   if (selected_building) {
  //     setPage(1);
  //     getBuildingOrders(1, limit);
  //   }
  // }, [sortBy]);

  /* ASYNC FUNCTIONS
	---------------------------------------------------------------------------------*/
  function doSearch(event) {
    const value = event.target.value.toString().toLowerCase();
    setSearchQuery(value);
  }

  function deleteSchedulerOrderApiCall(service_id) {
    const requestOptionsOrder = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    fetch(deleteSchedulerOrder + service_id, requestOptionsOrder)
      .then((response) => response.json())
      .then((res) => {
        if (res.code !== 200) {
          if (res?.version && res?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
        }
        if (res.status === 200) {
          setSearchQuery("");

          if (page === 1) {
            getBuildingOrders(1, limit);
          } else {
            setPage(1);
          }
        }
        addToast(res.message, {
          appearance: res.status === 200 ? "success" : "error",
          autoDismiss: true,
        });
      })
      .catch((error) => {
        console.log("Error:::::", error);
      });
  }

  async function goForEdit(id, isDraft) {
    const requestHeaders = {
      headers: {
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    set_mdl_progress(true);
    await fetch(
      orderDetailsGet + "?id=" + id + "&unit_number=" + null,
      requestHeaders,
    )
      .then((resposnse) => resposnse.json())
      .then(async (res) => {
        if (res.code === 200) {
          //setData(res.data);
          // await setSelectedBuilding({
          //   value: res.data.building_uuid,
          //   text: res.data.building_name,
          //   building_po_mo_wo: res.data.building_po_mo_wo,
          // });

          var temp_units = [];
          var validation_error_temp = [];
          var canEdit = true;
          res.data.units?.map((vals_units, index) => {
            var temp = { ...vals_units };
            temp.key = index;
            if (temp.follow_up) {
              temp.followup = "followup";
            } else if (temp.isFollowupMonthly) {
              temp.followup = "followup_month";
            } else if (temp.isImmediate) {
              temp.followup = "followup_immediately";
            } else if (temp.is_reschedule) {
              temp.followup = "reschedule";
            } else {
              temp.followup = "neworder";
            }
            temp.pest = temp.pest_name;
            temp.treatment = temp.treatment_name;
            validation_error_temp = [...validation_error_temp, {}];
            temp_units.push(temp);
          });
          if (canEdit) {
            await set_add_unit(temp_units);
            await setBuildingOrder({
              building_name: res.data.building_name,
              po_mo_wo: res.data.building_po_mo_wo,
            });
            await fetch(
              getSingleBuilding + res.data.building_uuid,
              requestHeaders,
            )
              .then((response) => response.json())
              .then((response) => {
                if (response.code !== 200) {
                  if (
                    response?.version &&
                    response?.version !== var_app_version
                  ) {
                    set_is_app_version_outdated(true);
                  }
                }
                const final_data = response.data[0];
                if (final_data) {
                  setSingleBuildingData(final_data);
                  setBuildingUnits(final_data.units ? final_data.units : []);
                }
              });
            if (isDraft) {
              history.push({
                pathname: "/scheduler-order-draft",
                state: {
                  order_id: res.data.order_id,
                  building_code: res.data.location_id,
                  building_uuid: res.data.building_uuid,
                  building_name: res.data.building_name,
                  id: res.data.id,
                  isDraft: true,
                  from: "building-impersonate",
                },
              });
            } else {
              history.push({
                pathname: "/scheduler-home/update-order",
                state: {
                  order_id: res.data.order_id,
                  building_code: res.data.location_id,
                  building_uuid: res.data.building_uuid,
                  text: res.data.building_name,
                  building_po_mo_wo: res.data.building_po_mo_wo,
                  id: res.data.id,
                  from: "building-impersonate",
                },
              });
            }
          } else {
            addToast("You cannot edit this order.", {
              appearance: "error",
              autoDismiss: true,
            });
          }
        } else {
          if (res?.version && res?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    set_mdl_progress(false);
  }

  async function getBuildingOrders(page_no, limit_range) {
    const requestHeaders = {
      headers: {
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    set_mdl_progress(true);
    await fetch(
      getAllOrdersOfUser +
        `?search=${searchQuery}&order_by=${
          current_sort?.sort_by || ""
        }&order_by_value=${current_sort?.sort_by_value || ""}&page=${
          page_no ? page_no : page
        }&sort_by=${parseInt(sortBy === 4 ? 2 : sortBy)}&limit=${
          limit_range
            ? limit_range === "all"
              ? 99999
              : limit_range
            : limit === "all"
              ? 99999
              : limit
        }&is_admin=false&id=` +
        selected_building,
      requestHeaders,
    )
      .then((response) => response.json())
      .then((res) => {
        if (res.code !== 200) {
          if (res?.version && res?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
        }
        set_mdl_progress(false);
        localStorage.setItem("popupDismissed", "true");
        var ordersFetch = [];
        if (res.statusCode === 200) {
          ordersFetch = res.body.data;
          setTotalOrders(res.body.total_count);
          // if(res.body && res.body.data && res.body.data.length === 0){
          //     //setPage(page-1)
          // }
        } else {
          ordersFetch = [];
        }
        if (page_no && page_no > 1) ordersFetch = [...orders, ...ordersFetch];
        setOrders(ordersFetch);
      })
      .catch((error) => {
        set_mdl_progress(false);
        console.error("Error:", error);
      });
  }

  async function syncOrderList(id) {
    const requestHeaders = {
      headers: {
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    set_mdl_progress(true);
    await fetch(syncScheduler + id, requestHeaders)
      .then((response) => response.json())
      .then((res) => {
        if (res.code !== 200) {
          if (res?.version && res?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
        }
        if (res.statusCode === 200) {
          setSearchQuery("");
          addToast(res?.body?.success, {
            appearance: "success",
            autoDismiss: true,
          });
          if (page === 1) {
            getBuildingOrders(1, limit);
          } else {
            setPage(1);
          }
        } else {
          addToast(
            res?.body?.error ||
              res?.body?.message ||
              res.error?.message ||
              "There is some server side issue. Please try again later.",
            {
              appearance: "error",
              autoDismiss: true,
            },
          );
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    set_mdl_progress(false);
  }

  /* EVENT FUNCTIONS
	---------------------------------------------------------------------------------*/

  function goViewDetail(id, unit_number) {
    history.push({ pathname: "/order-detail", state: { id, unit_number } });
  }

  function goViewDetails(id, unit_number) {
    history.push({
      pathname: "/complete-order",
      state: { id, unit_number, from: "building-impersonate" },
    });
  }

  async function getBuildingUnits() {
    const requestHeaders = {
      headers: {
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    await fetch(`${getSingleBuilding}${params.building_id}`, requestHeaders)
      .then((response) => response.json())
      .then((response) => {
        if (response.code !== 200) {
          if (response?.version && response?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
        }
        const final_data = response.data[0];
        setLocationId(final_data?.location_id);
        setSingleBuildingData(final_data);
        set_var_add_building(final_data);
        setBuildingUnits(final_data?.units ? final_data?.units : []);
      });
  }

  function handleUpdateBuilding(building_id) {
    set_buildingID(building_id);
    set_mdl_update_building(true);
  }

  async function getSchedulerData() {
    const requestHeaders = {
      headers: {
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    set_mdl_progress(true);
    await fetch(getListofScheduler, requestHeaders)
      .then((response) => response.json())
      .then((res) => {
        if (res.code !== 200) {
          if (res?.version && res?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
        }
        const formattedSchedulers = res.data.map((scheduler) => ({
          value: scheduler.value,
          text: `${scheduler.text} (${scheduler.email})`,
        }));
        setSchedulers(formattedSchedulers);
        set_mdl_progress(false);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  function onChangeSortBy(event, { value }) {
    setSortBy(value);
  }

  function handleOrderRequestClick() {
    set_add_unit([{ unit_number: "", followup: "neworder", key: 0 }]);
    history.push(`/building-impersonate/request-order/${selected_building}`);
  }

  async function downloadReport() {
    const requestHeaders = {
      headers: {
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    set_mdl_progress(true);
    try {
      await fetch(downloadPestTracker + selected_building, requestHeaders)
        .then((res) => res.json())
        .then((res) => {
          if (res.code !== 200) {
            if (res?.version && res?.version !== var_app_version) {
              set_is_app_version_outdated(true);
            }
          }
          if (res.statusCode === 200) {
            addToast(res.body.success, {
              appearance: "success",
              autoDismiss: true,
            });
          } else {
            addToast(res?.body?.error, {
              appearance: "error",
              autoDismiss: true,
            });
          }
        });
    } catch (error) {
      console.error("Error:", error);
    }
    set_mdl_progress(false);
  }

  /* RENDER APP
	---------------------------------------------------------------------------------*/

  return (
    <>
      <div className="app-content">
        <div className="app-backto-prev-page">
          <div
            className="app-goback-button"
            onClick={() => {
              setImpersonated(false);
              setSingleBuildingData([]);
              setSelectedBuilding();
              setOrderStatus("");
              set_default_pane(0);
              setShowHeaderSearch(!var_ShowHeaderSearch);
              const rawFrom = location?.state?.from;
              const cameFrom =
                typeof rawFrom === "string" ? rawFrom : rawFrom?.pathname;
              history.replace(cameFrom || "/scheduler-home");
            }}
          >
            <Icon name="arrow left" /> Go Back
          </div>
        </div>
        <div className="app-building-container">
          <div
            className="app-content-action building-impersonate-header"
            style={{
              marginBottom: "20px",
              backgroundColor: "white",
              border: "1px solid #f5f5f5",
              borderRadius: "10px",
              padding: "30px 20px",
            }}
          >
            <div className="building-impersonate-info">
              <div className="app-content-action-left-title building-impersonate-info-primary">
                <div
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                  onClick={() =>
                    handleUpdateBuilding(single_building_data?.location_id)
                  }
                >
                  <span style={{ fontWeight: "bold" }}>Location: </span>
                  {single_building_data?.location_id}
                </div>
                <div>
                  <span style={{ fontWeight: "bold" }}>Address :</span>{" "}
                  {single_building_data?.building_address}
                </div>
                <div>
                  <span style={{ fontWeight: "bold" }}>Client :</span>{" "}
                  {single_building_data?.customer_name}
                </div>
                <div>
                  <span style={{ fontWeight: "bold" }}>Email :</span>{" "}
                  <span className="building-impersonate-email">
                    {single_building_data?.email}
                  </span>
                </div>
              </div>
              <div className="app-content-action-left-title building-impersonate-info-secondary">
                <div>
                  <span style={{ fontWeight: "bold" }}>Master Pin: </span>
                  {single_building_data?.master_pin}
                </div>
                <div>
                  <span style={{ fontWeight: "bold" }}>Pin :</span>{" "}
                  {single_building_data?.building_pin}
                </div>
                <div>
                  <span style={{ fontWeight: "bold" }}>Scheduler :</span>{" "}
                  {single_building_data?.scheduler_name}
                </div>
                <div>
                  <span style={{ fontWeight: "bold" }}>Location Notes :</span>{" "}
                  {single_building_data?.location_note}
                </div>
              </div>
            </div>

            <div className="app-content-action-right">
              {/* <Button
                color="orange"
                onClick={() => {
                  // history.push(
                  //   `/critical-section`,
                  //   (state = { building_id: selected_building }),
                  // );
                  history.push({
                    pathname: "/critical-section",
                    state: { building_id: selected_building },
                  });
                }}
              >
                <img src="/alert.png" alt="icon" />
                Critical List
              </Button> */}

              <Button
                color="red"
                onClick={() => {
                  // save impersonation state
                  localStorage.setItem("impersonation", "true");
                  setImpersonatorID(user?.uuid);
                  set_default_pane(0);
                  const customerUser = {
                    role: "customer",
                    uuid: single_building_data?.uuid,
                    firstName: single_building_data?.building_name,
                  };
                  setUser(customerUser);
                  localStorage.setItem("user", JSON.stringify(customerUser));
                  const building = [
                    {
                      value: single_building_data?.uuid,
                      text: single_building_data?.building_name,
                      building_po_mo_wo:
                        single_building_data?.building_po_mo_wo,
                      customer_name: single_building_data?.customer_name,
                      location_id: single_building_data?.location_id,
                    },
                  ];
                  localStorage.setItem("building", JSON.stringify(building));
                  setSelectedBuilding(building[0]);
                  setBuildingInfo(building);
                  window.history.replaceState(null, "", "/home");
                  history.replace("/home");
                }}
              >
                <img src="/history.png" alt="icon" />
                Building Heatmap
              </Button>
              {/* <Button 
              color="blue"
              onClick={() => {
                history.push(`/building-history/${selected_building}`);
              }}>
                <img src="/history.png" alt="icon" />
                Building History
              </Button> 
             <Button color="red" onClick={() => handleOrderRequestClick()}>
              <img src="/request-order.svg" alt="icon" />
              Request Service
            </Button>  */}
              <Button
                color="red"
                onClick={() => {
                  // history.push(
                  //   `/building-impersonate/notes/${selected_building}`,
                  // );

                  history.push({
                    pathname: `/building-impersonate/notes/${selected_building}`,
                    state: { building_id: selected_building },
                  });
                }}
              >
                <img src="/order-list.svg" alt="icon" />
                Notes
              </Button>
            </div>
          </div>
          {/* <div className="app-card-header">
            <div className="app-page-title">
              <div className="app-card-title">
                {"Orders List (" + orders.length + ")"}
              </div>
            </div>
            {/* <div className="app-content-action app-content-action-search"> */}
          {/* <div className="app-content-action-right search-orders-list">
              {sortBy !== 2 && (
                <Search
                  placeholder="Search Unit Number"
                  onSearchChange={(value) => doSearch(value)}
                  showNoResults={false}
                  value={searchQuery}
                />
              )}
            </div> *
          </div> */}
          {/* <div className="app-card">
            <div className="app-card-header building-managment-header-card">
              <div className="app-card-title"></div>
              <div className="app-card-action" style={{ display: "flex" }}>
                <Popup
                  content="Download Pest Tracker Report" // Text to show on hover
                  trigger={
                    <img
                      style={{ marginTop: "5px", cursor: "pointer" }}
                      onClick={() => {
                        downloadReport();
                      }}
                      width="28"
                      height="25"
                      src={"/excel.png"}
                      alt="document"
                    />
                  }
                  position="top center" // Position of the tooltip
                />
                <Form.Select
                  className="sortby_optionss"
                  id="sortby_optionss"
                  name="sortby_optionss"
                  placeholder="Sort By"
                  label="Status: "
                  onChange={onChangeSortBy}
                  value={sortBy}
                  options={[
                    { key: 3, text: "All Orders", value: 3 },
                    { key: 0, text: "In Progress / Scheduled", value: 0 },
                    { key: 1, text: "Completed", value: 1 },
                    { key: 2, text: "Draft", value: 2 },
                    { key: 4, text: "Recommended", value: 4 },
                  ]}
                />
              </div>
              {/* <div className="app-content-search">
                    {sortBy != 2 && (
                    <Search
                    placeholder="Search Unit Number"
                    onSearchChange={(value) => doSearch(value)}
                    showNoResults={false}
                    value={searchQuery}
                    />
                )}
              </div> *
            </div>

            <div className="app-table-wrapper">
              <Table sortable unstackable>
                <Table.Header className="main-home-table">
                  {sortBy != 2 && sortBy != 4 ? (
                    <Table.Row>
                      <Table.HeaderCell
                        // icon={<Icon name="home" size="large" />}
                        sorted={
                          current_sort &&
                          current_sort.sort_by === "order_number"
                            ? current_sort.sort_by_value === "ASC"
                              ? "ascending"
                              : "descending"
                            : null
                        }
                        onClick={() => {
                          if (current_sort?.sort_by_value === "ASC") {
                            set_current_sorted({
                              sort_by: "order_number",
                              sort_by_value: "DESC",
                            });
                          } else {
                            set_current_sorted({
                              sort_by: "order_number",
                              sort_by_value: "ASC",
                            });
                          }
                        }}
                        title="Order #"
                      >
                        Order #
                        {current_sort?.sort_by !== "order_number" && (
                          <Icon size="20" name="sort" color="black" />
                        )}
                      </Table.HeaderCell>
                      <Table.HeaderCell title="Unit #">Unit #</Table.HeaderCell>
                      <Table.HeaderCell title="PO/MO/WO">
                        PO/MO/WO #
                      </Table.HeaderCell>
                      <Table.HeaderCell title="Location name">
                        Location
                      </Table.HeaderCell>
                      <Table.HeaderCell title="Pest">Pest</Table.HeaderCell>
                      <Table.HeaderCell title="Treatment">
                        Treatment
                      </Table.HeaderCell>

                      <Table.HeaderCell title="Current order status">
                        Status
                      </Table.HeaderCell>
                      <Table.HeaderCell
                        sorted={
                          current_sort && current_sort.sort_by === "work_date"
                            ? current_sort.sort_by_value === "ASC"
                              ? "ascending"
                              : "descending"
                            : null
                        }
                        onClick={() => {
                          if (current_sort?.sort_by_value === "ASC") {
                            set_current_sorted({
                              sort_by: "work_date",
                              sort_by_value: "DESC",
                            });
                          } else {
                            set_current_sorted({
                              sort_by: "work_date",
                              sort_by_value: "ASC",
                            });
                          }
                        }}
                        // icon={<Icon name="home" size="large" />}
                        title="Scheduled date"
                      >
                        {sortBy ? "Work" : "Schedule"} Date
                        {current_sort?.sort_by !== "work_date" && (
                          <Icon size="20" name="sort" color="black" />
                        )}
                      </Table.HeaderCell>
                      <Table.HeaderCell title="Order scheduler">
                        Time Window
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign="center">
                        Actions
                      </Table.HeaderCell>
                    </Table.Row>
                  ) : sortBy === 2 ? (
                    <Table.Row>
                      <Table.HeaderCell
                        sorted={
                          current_sort &&
                          current_sort.sort_by === "purchase_order_number"
                            ? current_sort.sort_by_value === "ASC"
                              ? "ascending"
                              : "descending"
                            : null
                        }
                        onClick={() => {
                          if (current_sort?.sort_by_value === "ASC") {
                            set_current_sorted({
                              sort_by: "purchase_order_number",
                              sort_by_value: "DESC",
                            });
                          } else {
                            set_current_sorted({
                              sort_by: "purchase_order_number",
                              sort_by_value: "ASC",
                            });
                          }
                        }}
                        title="PO/MO/WO"
                      >
                        PO/MO/WO #
                      </Table.HeaderCell>
                      <Table.HeaderCell title="No. of units">
                        Units
                      </Table.HeaderCell>
                      <Table.HeaderCell title="Treatment">
                        Treatment
                      </Table.HeaderCell>
                      <Table.HeaderCell
                        sorted={
                          current_sort &&
                          current_sort.sort_by === "order_date_time"
                            ? current_sort.sort_by_value === "ASC"
                              ? "ascending"
                              : "descending"
                            : null
                        }
                        onClick={() => {
                          if (current_sort?.sort_by_value === "ASC") {
                            set_current_sorted({
                              sort_by: "order_date_time",
                              sort_by_value: "DESC",
                            });
                          } else {
                            set_current_sorted({
                              sort_by: "order_date_time",
                              sort_by_value: "ASC",
                            });
                          }
                        }}
                        title="Saved Date"
                      >
                        Saved Date
                      </Table.HeaderCell>
                      <Table.HeaderCell title="Note">Note</Table.HeaderCell>
                      <Table.HeaderCell textAlign="center">
                        Actions
                      </Table.HeaderCell>
                    </Table.Row>
                  ) : sortBy === 4 ? (
                    <Table.Row>
                      <Table.HeaderCell
                        sorted={
                          current_sort &&
                          current_sort.sort_by === "purchase_order_number"
                            ? current_sort.sort_by_value === "ASC"
                              ? "ascending"
                              : "descending"
                            : null
                        }
                        onClick={() => {
                          if (current_sort?.sort_by_value === "ASC") {
                            set_current_sorted({
                              sort_by: "purchase_order_number",
                              sort_by_value: "DESC",
                            });
                          } else {
                            set_current_sorted({
                              sort_by: "purchase_order_number",
                              sort_by_value: "ASC",
                            });
                          }
                        }}
                        title="PO/MO/WO"
                      >
                        PO/MO/WO #
                      </Table.HeaderCell>
                      <Table.HeaderCell title="No. of units">
                        Units
                      </Table.HeaderCell>
                      <Table.HeaderCell title="Treatment">
                        Treatment
                      </Table.HeaderCell>
                      <Table.HeaderCell
                        sorted={
                          current_sort &&
                          current_sort.sort_by === "order_date_time"
                            ? current_sort.sort_by_value === "ASC"
                              ? "ascending"
                              : "descending"
                            : null
                        }
                        onClick={() => {
                          if (current_sort?.sort_by_value === "ASC") {
                            set_current_sorted({
                              sort_by: "order_date_time",
                              sort_by_value: "DESC",
                            });
                          } else {
                            set_current_sorted({
                              sort_by: "order_date_time",
                              sort_by_value: "ASC",
                            });
                          }
                        }}
                        title="Recommended Date"
                      >
                        Recommended Date
                      </Table.HeaderCell>
                      <Table.HeaderCell title="Note">Note</Table.HeaderCell>
                      <Table.HeaderCell textAlign="center">
                        Actions
                      </Table.HeaderCell>
                    </Table.Row>
                  ) : (
                    <Table.Row>
                      <Table.HeaderCell title="No. of units">
                        Units
                      </Table.HeaderCell>
                      <Table.HeaderCell title="PO/MO/WO">
                        PO/MO/WO #
                      </Table.HeaderCell>
                      <Table.HeaderCell title="Scheduler Name">
                        Scheduler
                      </Table.HeaderCell>
                      <Table.HeaderCell title="Scheduler Email">
                        Email
                      </Table.HeaderCell>
                      <Table.HeaderCell title="Date of request">
                        Requested Date
                      </Table.HeaderCell>
                      <Table.HeaderCell title="Current request Status">
                        Status
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign="center">
                        Actions
                      </Table.HeaderCell>
                    </Table.Row>
                  )}
                </Table.Header>
                <Table.Body>
                  {sortBy != 2 &&
                    sortBy != 4 &&
                    orders &&
                    orders.map((order, i) => (
                      <Table.Row key={i}>
                        <Table.Cell>{order.order_number}</Table.Cell>
                        <Table.Cell>{order.unit_number}</Table.Cell>
                        <Table.Cell>
                          {order?.purchase_order_number || "N/A"}
                        </Table.Cell>
                        <Table.Cell>{order.building_name}</Table.Cell>
                        <Table.Cell>{order.pest_name || "N/A"}</Table.Cell>
                        <Table.Cell>{order.treatment_name || "N/A"}</Table.Cell>
                        <Table.Cell className="td-status">
                          {order.order_status === "completed" && (
                            <div style={{ color: "#05881F" }}>Completed</div>
                          )}
                          {order.order_status === "posted" && (
                            <div style={{ color: "#05881F" }}>Posted</div>
                          )}
                          {order.order_status === "scheduled" && (
                            <div style={{ color: "#2196f3" }}>Scheduled</div>
                          )}
                          {order.order_status === "in progress" && (
                            <div style={{ color: "#FA8C16" }}>In Progress</div>
                          )}
                        </Table.Cell>
                        <Table.Cell>
                          {order.schedule_date &&
                          isValid(new Date(order.schedule_date))
                            ? moment(order.schedule_date).format("l")
                            : "N/A"}
                        </Table.Cell>
                        <Table.Cell>
                          {order.time_range ? order.time_range : "N/A"}
                        </Table.Cell>

                        {/* <Table.Cell
                          className="td-action"
                          collapsing
                          textAlign="right"
                        >
                          {order.order_status != "completed" ? (
                            <>
                              {/* <Label
                                color="red"
                                onClick={() =>
                                deleteOrderApiCall(
                                    order.unit_uuid,
                                    order.order_number,
                                    order.scheduler_email,
                                    order.building_name
                                )
                                }
                            >
                                Delete
                            </Label>
                              <Label
                                color="blue"
                                onClick={() =>
                                  goViewDetail(
                                    order.order_id,
                                    order.unit_number
                                  )
                                }
                              >
                                View
                              </Label>
                            </>
                          ) : (
                            <Label
                              color="blue"
                              onClick={() => {
                                set_selected_order(order.order_number);
                                set_pdf_url(viewPdfURL + order.order_number);
                                set_open_pdf_viewer(true);
                              }}
                            >
                              View Report
                            </Label>
                          )}
                        </Table.Cell> *
                        {/* new table actions *
                        <Table.Cell
                          className="td-action"
                          collapsing
                          textAlign="right"
                        >
                          <Label
                            color="green"
                            onClick={() => syncOrderList(order.order_id)}
                          >
                            Sync
                          </Label>
                          {order.order_status === "in progress" && (
                            <Label
                              color="blue"
                              onClick={() => goForEdit(order.order_id, false)}
                            >
                              Edit
                            </Label>
                          )}
                          {(order.order_status === "completed" ||
                            order.order_status === "scheduled" ||
                            order.order_status === "posted") && (
                            <Label
                              color="orange"
                              onClick={() =>
                                goViewDetails(order.order_id, null)
                              }
                            >
                              View
                            </Label>
                          )}
                          <Label
                            color="red"
                            onClick={() =>
                              deleteSchedulerOrderApiCall(order.order_id)
                            }
                          >
                            Delete
                          </Label>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  {sortBy == 2 &&
                    orders.map((order, i) => (
                      <Table.Row key={i}>
                        <Table.Cell>
                          {order?.purchase_order_number || "N/A"}
                        </Table.Cell>
                        <Table.Cell>
                          {order?.units
                            ?.slice(0, 3)
                            .map((unit) => unit.unit_number)
                            .join(", ")}
                          {order?.units?.length > 3 ? "..." : ""}
                        </Table.Cell>
                        <Table.Cell>
                          {order?.units
                            ?.slice(0, 3)
                            .map((treatment) => treatment.treatment_name)
                            .join(", ")}
                          {order?.units?.length > 3 ? "..." : ""}
                        </Table.Cell>
                        <Table.Cell>
                          {order.date && isValid(new Date(order.date))
                            ? moment(order.date).format("l")
                            : "N/A"}
                        </Table.Cell>
                        <Table.Cell>
                          {order?.units
                            ?.map((unit) => unit.note)
                            .filter((note) => note) // Remove empty notes
                            .slice(0, 3)
                            .join(", ")}
                          {order?.units
                            ?.map((unit) => unit.note)
                            .filter((note) => note).length > 3
                            ? "..."
                            : ""}
                        </Table.Cell>
                        <Table.Cell
                          className="td-action"
                          collapsing
                          textAlign="right"
                        >
                          <Label
                            color="blue"
                            onClick={() => goViewDetail(order.order_id, null)}
                          >
                            View
                          </Label>
                          {/* <Label
                            color="green"
                            onClick={() => goForEditDraft(order?.order_id)}
                        >
                            Edit
                        </Label>
                        <Label
                            color="red"
                            onClick={() => acceptAndRejectRequest(order, false)}
                        >
                            Reject
                        </Label> *
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  {sortBy == 4 &&
                    !var_mdl_progress &&
                    orders.map((order, i) => (
                      <Table.Row key={i}>
                        <Table.Cell>
                          {order?.purchase_order_number || "N/A"}
                        </Table.Cell>
                        <Table.Cell>
                          {order?.units
                            ?.slice(0, 3)
                            .map((unit) => unit.unit_number)
                            .join(", ")}
                          {order?.units?.length > 3 ? "..." : ""}
                        </Table.Cell>
                        <Table.Cell>
                          {order?.units
                            ?.slice(0, 3)
                            .map((treatment) => treatment.treatment_name)
                            .join(", ")}
                          {order?.units?.length > 3 ? "..." : ""}
                        </Table.Cell>
                        <Table.Cell>
                          {order.date && isValid(new Date(order.date))
                            ? moment(order.date).format("l")
                            : "N/A"}
                        </Table.Cell>
                        <Table.Cell>
                          {order?.units
                            ?.map((unit) => unit.note)
                            .filter((note) => note) // Remove empty notes
                            .slice(0, 3)
                            .join(", ")}
                          {order?.units
                            ?.map((unit) => unit.note)
                            .filter((note) => note).length > 3
                            ? "..."
                            : ""}
                        </Table.Cell>
                        <Table.Cell
                          className="td-action"
                          collapsing
                          textAlign="right"
                        >
                          {/* <Label
                            color="blue"
                            onClick={() => goViewDetail(order.order_id, null)}
                          >
                            View
                          </Label> *
                          <Label
                            color="green"
                            onClick={() => goForEdit(order?.order_id, true)}
                          >
                            Edit
                          </Label>
                          {/* <Label
                            color="red"
                            onClick={() => acceptAndRejectRequest(order, false)}
                        >
                            Reject
                        </Label> *
                        </Table.Cell>
                      </Table.Row>
                    ))}
                </Table.Body>
              </Table>
              {!var_mdl_progress && orders.length === 0 && (
                <div className="nodata-placeholder">
                  There is no order to display.
                </div>
              )}
            </div>
          </div>
          <div>
            <AppPagination
              limit={limit}
              setLimit={setLimit}
              page={page}
              setPage={setPage}
              rowsTotal={orders.length}
              totalCount={totalOrders}
              showAll={true}
            />
          </div> */}
        </div>
        <SchedulerOrderList isImpersonated={true} />
      </div>
      {/***** MODAL: UPDATE UNIT **************************************************************************/}
      <Modal
        id="mdl-update-building"
        dimmer={"inverted"}
        open={mdl_update_building}
        onClose={() => set_mdl_update_building(false)}
      >
        <MDL_UPDATE_BUILDING
          set_mdl_open={set_mdl_update_building}
          var_building_order={var_building_order}
          set_building_order={set_building_order}
          var_add_building={var_add_building}
          set_var_add_building={set_var_add_building}
          schedulers={schedulers}
        />
      </Modal>

      {/***** END MODAL: ADD UNIT **********************************************************************/}
      {/***** MODAL: PROGRESS **************************************************************************/}

      <Modal
        id="mdl-progress"
        dimmer={"inverted"}
        open={var_mdl_progress}
        closeOnDimmerClick={false}
        closeOnEscape={false}
        onClose={() => {}}
      >
        <MDL_PROGRESS
          set_mdl_open={set_mdl_progress}
          var_modaltitle="Please wait"
          var_message={"Please wait..."}
        ></MDL_PROGRESS>
      </Modal>

      {/***** END MODAL: PROGRESS **************************************************************************/}
      {/***** MODAL: PDF  VIEWER **************************************************************************/}
      <Modal
        id="mdl-pdf-viewer"
        dimmer={"inverted"}
        open={open_pdf_viewer}
        onClose={() => {
          set_open_pdf_viewer(false);
          set_pdf_url(null);
        }}
      >
        <CMP_PDF_VIEWER
          set_mdl_open={set_open_pdf_viewer}
          pdf_url={pdf_url}
          set_pdf_url={set_pdf_url}
          var_modaltitle={"Order #" + selected_order}
        />
      </Modal>
      {/***** MODAL: PDF  VIEWER **************************************************************************/}
      {/***** MODAL: ALERT **************************************************************************/}
      <Modal
        id="mdl-update-building"
        dimmer={"inverted"}
        open={var_mdl_alert}
        onClose={() => {
          set_mdl_alert(false);
        }}
      >
        <CMP_ALERT
          var_mdl_alert={var_mdl_alert}
          set_mdl_alert={set_mdl_alert}
          alert_message={alert_message}
        />
      </Modal>
      {/********* MODAL: ALERT **************************************************************************/}
    </>
  );
};

export default BuildingImpersonate;
